module.exports = __webpack_public_path__ + "static/portfolio_gallery_8-35692302aa4b3e11b3c69e58a2f2d0b1.jpg";